import React, {PureComponent} from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import Chip from "@material-ui/core/Chip";
import BarLoader from 'react-spinners/BarLoader';
import classNames from 'classnames';

class DropZoneField extends PureComponent {
  static propTypes = {
    customHeight: PropTypes.bool,
    isLoading: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.any,
    error: PropTypes.any,
    touched: PropTypes.any,
    modern: PropTypes.any,
    name: PropTypes.string,
    importxls: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  removeFile(index, e) {
    e.preventDefault();
    this.props.onChange(this.props.value.filter((val, i) => i !== index));
  }

  render() {
    const isLoading = this.props.isLoading;
    const { error, touched, modern, customHeight, name, importxls } = this.props;
    const files = this.props.value;
    let filesRestrictions;

    switch(name){
      case 'sat_certificate':
        filesRestrictions = 'application/x-x509-ca-cert, application/pkix-cert, application/keychain_access';
        break;

      case 'logo':
        filesRestrictions = 'image/jpeg, image/gif, image/png';
        break;

      case 'payment_files':
        filesRestrictions = 'image/jpeg, image/gif, image/png, .pdf';
        break;

      case 'xls_file':
        filesRestrictions = '.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;

      default:
        break;
    }

    const dropZoneClass = classNames({
      'dropzone': true,
      'dropzone--single': !modern,
      'dropzone__modern dropzone--multiple': modern,
      'dropzone--custom-height' : customHeight,
      'react-select-error-dropzone-border': touched && error,
      'dropzone__disable': customHeight && Array.isArray(files) && files.length > 0,
      'dropzone__xls': importxls
    })

    const dropzoneInput = classNames({
      'dropzone__input': true,
      'dropzone__not_width': files.length > 0
    })

    if (isLoading) {
      return (
        <div className={dropZoneClass}>
          <div className="spinner__table-page">
            <BarLoader sizeUnit={ "px" } size={ 24 } margin={ '0px' } color={ "#1e5799" } />
          </div>
        </div>
      );
    } // END

    return (
      <div className={dropZoneClass}>
        <Dropzone
          className={ dropzoneInput }
          accept={ filesRestrictions }
          name={ this.props.name }
          multiple={ false }
          onDrop={ filesToUpload => this.props.onChange(filesToUpload) }
        >
          {(!Array.isArray(files) || files.length === 0) &&
          <div className='dropzone__drop-here'><span className='lnr lnr-upload'/> Da click aquí <br/> o <br/> Arrastra tu archivo</div>}
        </Dropzone>
        {
          files && Array.isArray(files) && files.length > 0 &&
            <Chip
              label={files[0].name}
              onDelete={(e) => this.removeFile(0, e)}
              className="chip"
              color="primary"
            />
        }
      </div>
    )// END return
  }
}

const renderDropZoneField = ({ input, customHeight, modern, importxls, isLoading, meta: { touched, error } }) => {
  if (isLoading) {
    return (
      <div className='form__form-group-input-wrap'>
        <div className="spinner__table-page">
          <BarLoader sizeUnit={ "px" } size={ 24 } margin={ '0px' } color={ "#1e5799" } />
        </div>
      </div>
    );
  } // END

  return (
    <div className='form__form-group-input-wrap'>
      <DropZoneField
        { ...input }
        customHeight={ customHeight }
        isLoading={ isLoading }
        modern={ modern }
        importxls={ importxls }
        touched={ touched }
        error={ error }
      />
      { touched && error && <span className='react-select-error-dropzone'>{ error }</span> }
    </div>
  );
};

renderDropZoneField.propTypes = {
  input: PropTypes.object.isRequired,
  customHeight: PropTypes.bool
};

export default renderDropZoneField



// WEBPACK FOOTER //
// ./src/components/form/DropZone.js